import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admininfchv',
  templateUrl: './admininfchv.component.html',
  styleUrls: ['./admininfchv.component.css']
})
export class AdmininfchvComponent implements OnInit {

  constructor(
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  RegresarAdminInf(){
    this.router.navigate(['admininfo']);
  }

  IrConsultaInformacion(){
    this.router.navigate(['consultarinfochv']);
  }

  IrCargueMasivoInformacion(){
    this.router.navigate(['carguemasivoinfochv']);
  }

  IrActivarCargue(){
    this.router.navigate(['activarcarguechv']);
  }

  IrCrearNovedad(){
    this.router.navigate(['crearnovedadchv']);
  }

}
